import i18n from "../i18n";
import { DropdownOption, Gender } from "../types";

class ContactInfoServiceImpl {
  static _service: ContactInfoServiceImpl | undefined;
  static get(): ContactInfoServiceImpl {
    if (!this._service) {
      this._service = new ContactInfoServiceImpl();
    }
    return this._service;
  }

  genderIntValue(genderStr: string): number {
    return 0;
  }

  genderStringValue(genderInt: string): string {
    return "";
  }
  buildGenderDropdownOption(
    genderStr: string,
    value: string,
    selectedValue: string | undefined
  ): DropdownOption {
    return {
      value,
      displayText: i18n.t(`instabook.contacts.${genderStr}`),
      isSelected: selectedValue ? selectedValue === value : false,
    };
  }

  computeGenderOptions(selectedValue: number | undefined): DropdownOption[] {
    let options: DropdownOption[] = [];
    for (const [key, value] of Object.entries(Gender)) {
      options.push(
        this.buildGenderDropdownOption(
          key,
          value.toString(),
          selectedValue?.toString()
        )
      );
    }

    return options;
  }
}

export const contactInfoService = ContactInfoServiceImpl.get();
